// Front-end theme bundle entry point: wires up Swiper carousels, Foundation, and jQuery globals.
import $ from 'jquery';
import Swiper from 'swiper/core'; // was: 'swiper'
import { Navigation, Pagination } from 'swiper/modules';
import { Foundation, Toggler } from 'foundation-sites/dist/js/foundation.esm.js';

// Register the Navigation and Pagination modules
Swiper.use([Navigation, Pagination]);

// Ensure Swiper is attached to the global window object for inline scripts
window.Swiper = Swiper;

// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import '../../../scss/master.scss';

// Import all Swiper initializers
import { initNavigationSwiper } from './swipers/navigation';
import { initRSSFeedSwiper } from './swipers/rss-feed';
import { initQuerySwiper } from './swipers/query';
import { initTestimonialSwiper } from './swipers/testimonial';
import { initImageGallerySwiper } from './swipers/image-gallery';
import { initHorizontalTabsSwiper } from './swipers/tabs-horizontal';
import { initVerticalTabsSwiper } from './swipers/tabs-vertical';

// Explicitly attach jQuery and Swiper to the window object for WordPress compatibility
window.jQuery = $;
window.$ = $;

// Register Foundation Toggler plugin (used for mobile archive filter collapse)
Foundation.plugin(Toggler, 'Toggler');

/* Custom miscellaneous scripts */
$(document).ready(function () {
	// Initialize Foundation plugins (Toggler etc.)
	$(document).foundation();
	// Initialize all Swiper instances
	initNavigationSwiper();
	initRSSFeedSwiper();
	initQuerySwiper();
	initTestimonialSwiper();
	initImageGallerySwiper();
	initHorizontalTabsSwiper();
	initVerticalTabsSwiper();

	const childSidebar = $('.nav-section__list-item--has-children');
	$(childSidebar).click(function () {
		$(this).toggleClass('nav-section__list-item--is-active');
	});

	const stickyHeader = $('.sticky-header');
	$(window).scroll(function () {
		const scroll = $(window).scrollTop();

		if (scroll >= 300) {
			stickyHeader.css('opacity', '1');
			stickyHeader.css('visibility', 'visible');
		} else {
			stickyHeader.css('opacity', '0');
			stickyHeader.css('visibility', 'hidden');
		}
	});

	$(window).scroll(function () {
		const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
		const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
		const scrolled = (winScroll / height) * 100;
		const progress = document.getElementById('progress');
		if (progress) {
			progress.style.width = scrolled + '%';
		}
	});

	$('.masthead__trigger--site-nav').click(function () {
		if ($('#masthead').hasClass('masthead__nav--is-active')) {
			$('body').removeClass('no-scroll');
		} else {
			$('body').addClass('no-scroll');
		}
	});

	$(window).resize(function () {
		if ($(window).width() > 898) {
			$('body').removeClass('no-scroll');
			$('header').removeClass('masthead__nav--is-active');
		}
	});
});

import ready from './core/ready';

ready();
